export default "__VITE_ASSET__CsQaYsKn__"